const APP_STATE = {
  LOADED: "LOADED",
  LOADING: "LOADING",
  FAILED: "FAILED",
  NULL: "NULL",
};

export default APP_STATE;
